module.exports = __webpack_public_path__ + "static/media/Group_3579.70f7de33.png";